import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const getVendorPaymentRecord = createAsyncThunk(
  "VendorDetail/getVendorPaymentRecord",
  async (data, thunkAPI) => {
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/vendors/payment_records/${data.id}?pageNumber=${data.pageNumber}&pageSize=${data.pageSize}&sortBy=&sortOrder=desc&search=${data.search}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return resp.data?.data;
    } catch (error) {
      if (error.response) {
        return thunkAPI.rejectWithValue(error.response.data.errorMessage || error.response.data.message);
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);

